import React from 'react';
import CommerceDocPublicPage from './CommerceDocPublicPage';

export default function ReceiptPublic() {
  return <CommerceDocPublicPage mode="receipt" />;
}
